import type { Article } from "../types/article";

export const mockArticles: Article[] = [
    {
        id: 1,
        slug: "journee-5-dimanche-22-mars-guenange",
        title: "Journée 5 : rendez-vous le dimanche 22 mars à Guénange",
        excerpt:
            "Trois affiches au programme avec Sénégal, Camerlux, Lions Indomptables, FPM et CSGL dans une ambiance festive.",
        content:
            "La Ligue des 2 Zéros du Luxembourg et des 3 Frontières donne rendez-vous au public pour la Journée 5 au Stade Léo Lagrange à Guénange. Cette journée mettra en avant plusieurs rencontres très attendues ainsi qu’un grand moment de convivialité autour des supporters et des familles.",
        category: "Journée",
        image: "/images/news/journee-5.jpg",
        publishedAt: "20 mars 2026",
        author: "Rédaction Ligue 2 Zéros",
        featured: true,
    },
    {
        id: 2,
        slug: "barbecue-geant-a-guenange",
        title: "Barbecue géant annoncé de 9h à 18h lors de la Journée 5",
        excerpt:
            "La journée sportive sera accompagnée d’un barbecue géant pour prolonger l’expérience des supporters.",
        content:
            "En marge des rencontres sportives, les organisateurs annoncent un barbecue géant ouvert au public afin de renforcer l’esprit communautaire et festif de la ligue.",
        category: "Événement",
        image: "/images/news/barbecue-geant.jpg",
        publishedAt: "20 mars 2026",
        author: "Organisation",
    },
    {
        id: 3,
        slug: "programme-officiel-journee-5",
        title: "Le programme officiel de la Journée 5 est disponible",
        excerpt:
            "Découvrez les horaires, les poules et les affiches prévues ce dimanche 22 mars.",
        content:
            "Le programme officiel présente les matchs de Poule A et Poule B, les horaires de début et les informations pratiques relatives à la journée.",
        category: "Annonce",
        image: "/images/news/programme-j5.jpg",
        publishedAt: "19 mars 2026",
        author: "Commission communication",
    },
    {
        id: 4,
        slug: "focus-camerlux-avant-la-journee-5",
        title: "Focus sur Camerlux avant une journée décisive",
        excerpt:
            "Camerlux aborde cette nouvelle journée avec ambition et l’envie de confirmer sa dynamique.",
        content:
            "Le club arrive avec confiance et veut transformer cette journée en signal fort envoyé au championnat.",
        category: "Interview",
        image: "/images/news/article-default.jpg",
        publishedAt: "18 mars 2026",
        author: "Rédaction Ligue 2 Zéros",
    },
    {
        id: 5,
        slug: "communique-supporters-dimanche",
        title: "Communiqué aux supporters pour l’accueil du public dimanche",
        excerpt:
            "Les organisateurs rappellent les consignes d’accès, de stationnement et de sécurité pour la Journée 5.",
        content:
            "Afin de garantir une organisation fluide, plusieurs recommandations sont communiquées aux participants et aux visiteurs attendus sur site.",
        category: "Communiqué",
        image: "/images/news/article-default.jpg",
        publishedAt: "18 mars 2026",
        author: "Bureau d’organisation",
    },
    {
        id: 6,
        slug: "les-affiches-a-surveiller-ce-weekend",
        title: "Les affiches à surveiller ce week-end",
        excerpt:
            "Plusieurs confrontations promettent intensité, rivalité et spectacle dans cette nouvelle journée.",
        content:
            "Cette journée devrait proposer des oppositions équilibrées et très suivies par les supporters des différentes communautés.",
        category: "Annonce",
        image: "/images/news/article-default.jpg",
        publishedAt: "17 mars 2026",
        author: "Rédaction Ligue 2 Zéros",
    },
];